import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS, SHOW_MESSAGE } from '../../@jumbo/constants/ActionTypes';

export const showMessage = message => ({ type: SHOW_MESSAGE, payload: message });

export const fetchSuccess = () => ({ type: FETCH_SUCCESS });

export const fetchError = error => ({ type: FETCH_ERROR, payload: error });

export const fetchStart = () => ({ type: FETCH_START });
